import React from 'react'
import { Row, Col, Card, Statistic, Typography, Table, Tag } from 'antd'
import { 
  BarChartOutlined, 
  TeamOutlined,
  FileTextOutlined
} from '@ant-design/icons'

const { Title, Text } = Typography

interface StatsOverviewProps {
  data: any
  dimension: string
}

const StatsOverview: React.FC<StatsOverviewProps> = ({ data, dimension }) => {
  if (!data) {
    return (
      <div style={{ textAlign: 'center', color: '#999', padding: '40px' }}>
        请先选择查询条件并生成统计
      </div>
    )
  }

  if (dimension === '机构维度') {
    const { 
      summary, 
      roles_distribution, 
      type_distribution, 
      yearly_trend, 
      co_drafting_partners, 
      classification_distribution 
    } = data

    return (
      <div>
        {/* 基本统计 */}
        <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
          <Col span={8}>
            <Card>
              <Statistic
                title="相关标准总数"
                value={summary?.相关标准总数 || 0}
                prefix={<FileTextOutlined />}
                valueStyle={{ color: '#1890ff' }}
              />
            </Card>
          </Col>
          <Col span={8}>
            <Card>
              <Statistic
                title="机构名称"
                value={summary?.机构名称 || '未知'}
                prefix={<TeamOutlined />}
                valueStyle={{ color: '#52c41a' }}
              />
            </Card>
          </Col>
          <Col span={8}>
            <Card>
              <Statistic
                title="统计时间"
                value={new Date().toLocaleDateString()}
                prefix={<BarChartOutlined />}
                valueStyle={{ color: '#fa8c16' }}
              />
            </Card>
          </Col>
        </Row>

        {/* 标准详情列表 - 移到最前面 */}
        {summary?.标准详情列表 && summary.标准详情列表.length > 0 && (
          <Card title="标准详情列表" style={{ marginBottom: 24 }}>
            <Table
              dataSource={summary.标准详情列表}
              columns={[
                {
                  title: '标准号',
                  dataIndex: '标准号',
                  key: '标准号',
                  render: (text: string) => <Tag color="blue">{text}</Tag>
                },
                {
                  title: '标准名称',
                  dataIndex: '标准名称',
                  key: '标准名称',
                  render: (text: string) => <Text>{text}</Text>
                },
                {
                  title: '标准类别',
                  dataIndex: '标准类别',
                  key: '标准类别',
                  render: (text: string) => <Tag color="green">{text}</Tag>
                },
                {
                  title: '发布年份',
                  dataIndex: '发布年份',
                  key: '发布年份',
                  render: (text: string) => <Tag color="orange">{text}</Tag>
                }
              ]}
              pagination={{ pageSize: 10 }}
              size="small"
              scroll={{ x: 600 }}
            />
          </Card>
        )}



        {/* 角色分布 */}
        {roles_distribution && roles_distribution.length > 0 && (
          <Card title="角色分布" style={{ marginBottom: 16 }}>
            <Table
              dataSource={roles_distribution}
              columns={[
                {
                  title: '机构角色',
                  dataIndex: '机构角色',
                  key: '机构角色',
                  render: (text: string) => <Tag color="blue">{text}</Tag>
                },
                {
                  title: '标准数量',
                  dataIndex: '标准数量',
                  key: '标准数量',
                  render: (value: number) => <Text strong>{value}</Text>
                }
                // {
                //   title: '标准详情',
                //   dataIndex: '标准列表',
                //   key: '标准列表',
                //   render: (list: any[]) => (
                //     <div style={{ maxHeight: '100px', overflowY: 'auto' }}>
                //       {list?.slice(0, 3).map((item: any, index: number) => (
                //         <div key={index} style={{ fontSize: '12px', marginBottom: '2px' }}>
                //           {item.标准号} - {item.标准名称}
                //         </div>
                //       ))}
                //       {list?.length > 3 && <Text type="secondary">...等{list.length}项</Text>}
                //     </div>
                //   )
                // }
              ]}
              pagination={false}
              size="small"
            />
          </Card>
        )}

        {/* 类型分布 */}
        {type_distribution && type_distribution.length > 0 && (
          <Card title="标准类型分布" style={{ marginBottom: 16 }}>
            <Table
              dataSource={type_distribution.filter((item: any) => item.参与数量 > 0)}
              columns={[
                {
                  title: '标准类别',
                  dataIndex: '标准类别',
                  key: '标准类别',
                  render: (text: string) => <Tag color="green">{text}</Tag>
                },
                {
                  title: '参与数量',
                  dataIndex: '参与数量',
                  key: '参与数量',
                  render: (value: number) => <Text strong>{value}</Text>
                }
              ]}
              pagination={false}
              size="small"
            />
          </Card>
        )}

        {/* 时间趋势 */}
        {yearly_trend && yearly_trend.length > 0 && (
          <Card title="年度产出趋势" style={{ marginBottom: 16 }}>
            <Table
              dataSource={yearly_trend}
              columns={[
                {
                  title: '发布年份',
                  dataIndex: '发布年份',
                  key: '发布年份',
                  render: (text: number) => <Tag color="orange">{text}</Tag>
                },
                {
                  title: '年度发布数量',
                  dataIndex: '年度发布数量',
                  key: '年度发布数量',
                  render: (value: number) => <Text strong>{value}</Text>
                }
              ]}
              pagination={false}
              size="small"
            />
          </Card>
        )}

        {/* 机构合作 */}
        {co_drafting_partners && co_drafting_partners.length > 0 && (
          <Card title="合作机构" style={{ marginBottom: 16 }}>
            <Table
              dataSource={co_drafting_partners}
              columns={[
                {
                  title: '合作机构',
                  dataIndex: '合作机构',
                  key: '合作机构',
                  render: (text: string) => <Tag color="purple">{text}</Tag>
                },
                {
                  title: '共同起草数量',
                  dataIndex: '共同起草数量',
                  key: '共同起草数量',
                  render: (value: number) => <Text strong>{value}</Text>
                }
              ]}
              pagination={false}
              size="small"
            />
          </Card>
        )}

        {/* 领域分布 */}
        {classification_distribution && classification_distribution.length > 0 && (
          <Card title="领域分布(CCS分类)" style={{ marginBottom: 16 }}>
            <Table
              dataSource={classification_distribution.filter((item: any) => item.数量 > 0)}
              columns={[
                {
                  title: '分类号',
                  dataIndex: '分类号',
                  key: '分类号',
                  render: (text: string) => <Tag color="cyan">{text}</Tag>
                },
                {
                  title: '分类名称',
                  dataIndex: '分类名称',
                  key: '分类名称',
                  render: (text: string) => <Text>{text || '-'}</Text>
                },
                {
                  title: '数量',
                  dataIndex: '数量',
                  key: '数量',
                  render: (value: number) => <Text strong>{value}</Text>
                }
              ]}
              pagination={false}
              size="small"
            />
          </Card>
        )}

      </div>
    )
  }

  // 人员维度统计
  return (
    <div style={{ textAlign: 'center', color: '#999', padding: '40px' }}>
      <Title level={4}>人员统计功能开发中</Title>
      <Text>敬请期待...</Text>
    </div>
  )
}

export default StatsOverview
